/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


export default new class
{
  serialize (value)
  {
    return JSON.stringify(value);
  }


  deserialize (value)
  {
    return JSON.parse(value);
  }


}();
